import * as React from 'react';

import { CardAccounts } from '../../../../roadmap/components/go/CardAccounts';

export default function CardAccountsScreen() {
    return <CardAccounts />;
}
